import React, { useState, useRef, useCallback, useEffect } from "react";
import {
  Button,
  Row,
  Table,
  Input,
  Col,
  Modal,
  Form,
  Tooltip,
  Select,
  Tag,
} from "antd";
import {
  PlusOutlined,
  SearchOutlined,
  QuestionCircleOutlined,
  DeleteOutlined,
  EditOutlined,
} from "@ant-design/icons";
import { useHistory } from "react-router-dom";
import Highlighter from "react-highlight-words";
import { withAppContext } from "contexts/AppContext/AppContext";
import { getLabelOfConstant } from "utils/general";
import { buildPPISummaryUri } from "utils/routes";
import moment from "moment";
import Locale from "react-intl-universal";

const BirthdayList = (props) => {
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState();

  const [searchText, setSearchText] = useState("");
  const [searchInput, setSearchInput] = useState("");

  useEffect(() => {
    if (props.data) {
      setData(props.data);
      console.log("props", props);
    }
  }, [props]);

  const handleOnRow = (record) => ({
    onClick: () => history.push(buildPPISummaryUri(record._id)),
  });

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            setSearchInput(node);
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Button
          type="primary"
          onClick={() => handleSearch(selectedKeys, confirm)}
          icon={<SearchOutlined />}
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          Search
        </Button>
        <Button
          onClick={() => handleReset(clearFilters)}
          size="small"
          style={{ width: 90 }}
        >
          Reset
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        style={{
          marginRight: 8,
          fontSize: 18,
          color: filtered ? "#ffc069" : undefined,
        }}
      />
    ),
    onFilter: (value, record) => {
      console.log(record);
      if (record[dataIndex]) {
        return record[dataIndex]
          .toString()
          .toLowerCase()
          .includes(value.toLowerCase());
      } else {
        return false;
      }
    },
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput);
      }
    },
    render: (text) => {
      if (text) {
        return (
          <Highlighter
            highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
            searchWords={[searchText]}
            autoEscape
            textToHighlight={text.toString()}
          />
        );
      }
    },
  });

  const handleSearch = (selectedKeys, confirm) => {
    confirm();
    setSearchText(selectedKeys[0]);
  };

  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText("");
  };

  const columns = [
    {
      title: Locale.get("Dashboard.dashboardComponent.fullName"),
      dataIndex: "name",
      key: "name",
      //   sorter: (a, b) => a.name?.localeCompare(b.name),
      ...getColumnSearchProps("fullName"),
    },
    {
      title: Locale.get("Dashboard.dashboardComponent.dob"),
      dataIndex: "dob",
      key: "dob",
      sortDirections: ["descend", "ascend"],
      sorter: (a, b) => moment(a.dob).unix() - moment(b.dob).unix(),
      //   sorter: (a, b) => a.dob?.localeCompare(b.dob),
      //   ...getColumnSearchProps('dob'),
      render: (v) => {
        return moment(v).format("YYYY-MM-DD");
      },
    },
    {
      title: Locale.get("Dashboard.dashboardComponent.age"),
      dataIndex: "age",
      key: "age",
      sortDirections: ["descend", "ascend"],
      sorter: (a, b) => a.age - b.age,
      //   ...getColumnSearchProps('age'),
      //   render: (v) => (v ? v : '-')
    },
    {
      title: Locale.get("Dashboard.dashboardComponent.contact"),
      dataIndex: "contact",
      key: "contact",
      // sorter: (a, b) => a.contact?.localeCompare(b.contact),
      ...getColumnSearchProps("contact"),
      render: (v) => (v ? v : "-"),
    },
    {
      title: Locale.get("Dashboard.dashboardComponent.category"),
      dataIndex: "category",
      key: "category",
      // sorter: (a, b) => a.category?.localeCompare(b.category),
      // ...getColumnSearchProps('category')
      render: (category) => {
        if (category === "client") {
          return (
            <Tag color={"#389e0d"}>
              {Locale.get("Dashboard.dashboardComponent.clientTag")}
            </Tag>
          );
        } else if (category === "prospect") {
          return Locale.get("Dashboard.dashboardComponent.prospect");
        } else {
          return category;
        }
      },
    },
  ];

  return (
    <div>
      <div style={{ fontSize: 24, fontWeight: "bold", color: "black" }}>
        {Locale.get("Dashboard.dashboardComponent.birthdayList")}
      </div>

      <Table
        size="large"
        rowKey="_id"
        columns={columns}
        loading={loading}
        onRow={handleOnRow}
        dataSource={data}
        scroll={{ scrollToFirstRowOnChange: true, x: true }}
      />
    </div>
  );
};

export default withAppContext(BirthdayList);
